<template>
  <div class="min-h-screen bg-gray-50">
    <header class="bg-white border-b border-gray-200 shadow-sm">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8 text-blue-600"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z"
              />
            </svg>
            <span class="ml-2 text-xl font-semibold text-gray-800"
              >Cutting Optimizer</span
            >
          </div>
          <nav class="flex space-x-4">
            <NuxtLink
              to="/"
              class="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 transition-colors"
              @click="trackButtonClick('Navigation - Home', 'navigation')"
              >Home</NuxtLink
            >
            <NuxtLink
              to="/optimizer"
              class="px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 transition-colors"
              @click="trackButtonClick('Navigation - Optimizer', 'navigation')"
              >Optimizer</NuxtLink
            >
          </nav>
        </div>
      </div>
    </header>

    <main class="py-6">
      <NuxtPage />
    </main>

    <footer class="bg-white border-t border-gray-200 mt-auto">
      <div class="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <div class="text-center text-sm text-gray-500">
          &copy; {{ new Date().getFullYear() }} Cutting Optimizer. All rights |
          <a href="mailto:budi@avasoft.co" class="text-blue-600 hover:underline"
            >budi@avasoft.co</a
          >
          reserved.
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
  // Initialize analytics tracking for navigation
  const { trackButtonClick } = useAnalytics();
</script>

<style>
  body {
    font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont,
      'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  }

  .page-enter-active,
  .page-leave-active {
    transition: opacity 0.3s, transform 0.3s;
  }

  .page-enter-from,
  .page-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }
</style>
